import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";
import videoSource from "../../assets/videos/CB.mp4";
import videoSource1 from "../../assets/videos/ST_Demo.mp4";
import architecture from "../../assets/images/resource/Secure_AI_chatbot.png";
import FooterOne from "../Footer/FooterOne";
import SorBanner from "./../../assets/images/banner/azure-ai.png";
import cb from "./../../assets/images/icons/cb.jpg";
import msa from "./../../assets/images/icons/msa.png";

const Chatbot = () => {
  pageTitle("Chatbot");

  return (
    <>
      <HeaderOne></HeaderOne>

      <div className="ai-overlay-wrapper">
        <img src={SorBanner} alt="AI Operations" className="main" />

        <div className="ai-overlay">
          {/* Centered text */}
          <img
            src={msa}
            alt="Microsoft azure"
            className="ai-overlay-corner-img"
          />
          <div className="ai-overlay-center-text">
          
              <h2>Azure Secure AI Chatbot </h2>
              <p>
                <img
                  src={cb}
                  alt="Microsoft azure"
                  style={{ height: "30px" }}
                />{" "}
                Chatbot
              </p>
            
          </div>
        </div>
      </div>

      <section class="siw-rpa-section">
        <div class="siw-rpa-container-data-engineering container">
          <div class="siw-rpa-content">
            {/* <span class="siw-rpa-tag">
              Still Manually Searching item codes & rates in SOR (Schedule of
              Rates) documents?
            </span> */}

            <div className="siw-rpa-text">
              <p>
                Power secure, intelligent conversations with a Microsoft Azure
                chatbot solution.
              </p>
            </div>

            <div className="siw-rpa-desc">
              <h3 className="pb-2">Key Capabilities</h3>
              <p>
                This solution delivers a secure and scalable AI chatbot
                experience through an Azure-powered architecture that supports
                business information retrieval, intelligent responses, and
                operational monitoring:
              </p>
              <p
                className="py-2"
                style={{ fontWeight: "bold", color: "#009999" }}
              >
                The Six-Step Workflow
              </p>
              <ol>
                <li>
                  Web Application – Users interact with the chatbot through a
                  secure web interface.
                </li>
                <li>
                  Authentication – Access control mechanisms protect users and
                  application data.
                </li>
                <li>
                  Backend Agent Service – A central orchestration layer manages
                  the end-to-end workflow.
                </li>
                <li>
                  AI Search – The system retrieves relevant business knowledge
                  and contextual data.
                </li>
                <li>
                  Large Language Model – AI generates accurate, intelligent, and
                  contextual responses.
                </li>
                <li>
                  Monitoring Tools – System performance, reliability, and health
                  are continuously tracked.
                </li>
              </ol>
            </div>
          </div>

          <div class="siw-rpa-cta">
            <h4 style={{ color: "rgb(230, 233, 55)" }}>Free Trial Available</h4>
            <p>
              <span style={{ fontSize: "20px", fontWeight: "bold" }}>SiW</span>{" "}
              is currently offering a free trial session. <br />
              Our team will create a dedicated Azure AI Services.
            </p>
            <p className="siw-project-website-text-top">
              To explore more about the{" "}
              <strong>Azure Secure AI Chatbot,</strong>
              <br />
              Click 👉{" "}
              <a
                href="https://aai.siw.sg/"
                target="_blank"
                rel="noopener noreferrer"
                className="siw-project-website-link blinking1"
              >
                Azure Secure AI Chatbot
              </a>
              .
            </p>
            <a href="/contact" class="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              Start a Free Trial
            </a>
          </div>
        </div>
      </section>
      <div className="container" style={{ marginTop: "-10px" }}>
        <div className="siw-rpa-desc mt-0">
          <h3>Architecture</h3>
          <p className="pt-2">
            This architectural diagram illustrates the secure workflow of a
            cloud-based chatbot integrated within the Microsoft Azure ecosystem.
            The process begins when a user accesses a web application, which
            utilizes built-in authentication to ensure protected access before
            communicating with a backend agent service. This central service
            acts as an orchestrator, retrieving relevant information through AI
            search capabilities and generating intelligent responses via a large
            language model. Finally, the entire infrastructure is supported by
            integrated monitoring tools that track performance and system health
            to ensure a reliable user experience.
          </p>
          <img
            src={architecture}
            alt="Computer Vision"
            className="siw-rpa-desc-img"
          />
        </div>
      </div>

      <section className="siw-project-section">
        <div className="siw-project-container container">
          <div className="row g-4 align-items-start">
            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">
                Introducing Azure Secure AI Chatbot
              </h3>

              <div className="siw-project-video-wrapper">
                <video className="siw-project-video" controls>
                  <source src={videoSource} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>

            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">Watch a Demo Video</h3>

              <div className="siw-project-video-wrapper">
                <video className="siw-project-video" controls>
                  <source src={videoSource1} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
          <p className="siw-project-website-text">
            To explore more about the <strong>Azure Secure AI Chatbot </strong>,
            Click 👉{" "}
            <a
              href="https://aai.siw.sg/"
              target="_blank"
              rel="noopener noreferrer"
              className="siw-project-website-link blinking"
            >
              Azure Secure AI Chatbot
            </a>
            .
          </p>
        </div>
      </section>
      <FooterOne></FooterOne>
    </>
  );
};
export default Chatbot;
